(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6182],{

/***/ 26582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51945);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97565);
/* harmony import */ var layouts_application__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8182);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);
/* eslint no-undef: 0 */

/* eslint arrow-parens: 0 */









var Title = antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Title */ .Z.Title;

var description = function description() {
  return "A Personal Finance FAQ portal for India, Canada & USA investors. Financial education hub sharing broker\nreviews, stock market queries, trading & investment software and apps.";
};

var Ipos = function Ipos(props) {
  var pageSizeCount = 20;
  var records = props.data;
  var allBrokers = records.all_brokers,
      allCalculators = records.all_calculators,
      allPages = records.all_pages.data,
      filedRecords = records.filed_ipos.data;
  var total = props.data.filed_ipos.meta.pagination.total;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var _router$query$page = router.query.page,
      page = _router$query$page === void 0 ? 1 : _router$query$page;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var cookies = (0,nookies__WEBPACK_IMPORTED_MODULE_5__.parseCookies)();

    if (!cookies.country) {
      (0,nookies__WEBPACK_IMPORTED_MODULE_5__.setCookie)(null, 'country', 'us', {
        path: ['/'] // cookie path

      });
    }
  }, []);
  var columns = [{
    title: 'Symbol',
    dataIndex: 'symbol',
    key: 'symbol',
    render: function render(text, record) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/ipos/".concat(record.slug),
        children: text
      });
    }
  }, {
    title: 'Company Name',
    dataIndex: 'companyName',
    key: 'companyName',
    render: function render(text, record) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/ipos/".concat(record.slug),
        children: text
      });
    }
  }, {
    title: 'Date Filed',
    dataIndex: 'dateFiled',
    key: 'dateFiled'
  }, {
    title: 'Offer Amount',
    dataIndex: 'offerAmount',
    key: 'offerAmount'
  }];
  var dataSource = filedRecords.map(function (item) {
    return {
      slug: item.attributes.slug,
      key: item.id,
      symbol: item.attributes.symbol,
      companyName: item.attributes.name,
      dateFiled: item.attributes.filed_date,
      offerAmount: item.attributes.offer_amount
    };
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(layouts_application__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    allBrokers: allBrokers.data,
    navCalculators: allCalculators.data,
    allPages: allPages,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("title", {
        children: ["Latest Upcoming IPOs on NASDAQ - Fintrakk - Page ", page || 1]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("meta", {
        name: "description",
        content: description()
      }), page === '1' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("link", {
        rel: "canonical",
        href: "/ipos/all"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      className: "page-wrapper page",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        xs: 24,
        md: 16,
        sm: 24,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Title, {
          className: "title-wrapper",
          children: "Filings"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(antd__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          columns: columns,
          dataSource: dataSource,
          bordered: true,
          pagination: {
            current: parseInt(page, 10),
            pageSize: pageSizeCount,
            showSizeChanger: false,
            total: total,
            onChange: function onChange(changedPage) {
              router.push("/ipos/all/".concat(changedPage.toString()));
            }
          },
          scroll: {
            x: true
          }
        })]
      })
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Ipos);

/***/ }),

/***/ 43897:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ipos/all/[[...page]]",
      function () {
        return __webpack_require__(26582);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,7752,2913,1945,7527,2841,7565,3770,8182,9774,2888,179], function() { return __webpack_exec__(43897); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);